import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGE } from '@src/constants';
import BannerEn from '@src/assets/images/educator-banner-en.webp';
import BannerVi from '@src/assets/images/educator-banner-vi.webp';
import { StyledEducatorsHomeBanner } from './index.style';

const Banner = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  // The headline is part of the artwork, so localising the banner means picking
  // a different image. Only vi and en are drawn; anything else falls back to
  // the English one, the same way i18n falls back for its strings.
  const bannerSrc = language === LANGUAGE.VN ? BannerVi : BannerEn;

  return (
    <StyledEducatorsHomeBanner>
      <img src={bannerSrc} alt={t('vbeeForEducators')} />
    </StyledEducatorsHomeBanner>
  );
};

export default Banner;
